export default __webpack_public_path__ + "static/media/session_as_disciple.0b1388e7.svg";